import React from "react"

import { useTestSetEditorContext } from "../../contexts/TestSetEditorContext"
import type { EditableTestCase } from "../../model"
import { MetadataColumnCell } from "./cells/MetadataColumnCell"
import { METADATA_COLUMN_WIDTH } from "./MetadataColumnHeaders"

interface MetadataColumnCellsProps {
  testCase: EditableTestCase
  isExpanded: boolean
  isMarkedForDeletion?: boolean
}

/**
 * Renders one cell per visible metadata column for a single test case row.
 * The trailing narrow `<td>` aligns with the metadata settings `<th>`.
 */
export const MetadataColumnCells: React.FC<MetadataColumnCellsProps> = ({
  testCase,
  isExpanded,
  isMarkedForDeletion,
}) => {
  const { metadataColumns, metadataColumnState } = useTestSetEditorContext()
  const { overrides, hiddenKeys } = metadataColumnState

  const visibleColumns = metadataColumns.filter((c) => !hiddenKeys.has(c.key))

  if (visibleColumns.length === 0) {
    return null
  }

  return (
    <>
      {visibleColumns.map((column) => {
        const effectiveType = overrides[column.key] ?? column.inferredType
        return (
          <MetadataColumnCell
            key={column.key}
            testCase={testCase}
            columnKey={column.key}
            columnType={effectiveType}
            width={METADATA_COLUMN_WIDTH}
            isExpanded={isExpanded}
            isMarkedForDeletion={isMarkedForDeletion}
          />
        )
      })}
    </>
  )
}
